<template>
  <div class='container mt-2 basic-info'>
    <div class='col-md'>
      <div class='card'>
        <div class='card-body'>
          <div class='col-md-12'>
            <div class='row'>
              <div class='col-md-6'>
                <h5 class='float-start card-title'>Payment History</h5>
              </div>
              <div class='col-md-6'>
                <select class='form-select form-select-xs mb-3 float-end' aria-label='Default select example'>
                  <option value='Last Two Month'>Last Two Month</option>
                  <option value='Last Three Month'>Last Three Month</option>
                  <option value='Last Four Month'>Last Four Month</option>
                </select>
              </div>
            </div>
          </div>
          <br>
          <div class='col-md-12'>
            <div class='row'>
              <div v-if='isLoading' class='container'>
                <div class='d-flex justify-content-center mt-5'>
                  <loader></loader>
                </div>
              </div>
              <div v-else>
                <table class='table table-bordered'>
                  <thead>
                  <th>Transaction ID</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Mode of Payment</th>
                  <th>Disbursed by</th>
                  </thead>
                  <tbody>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  <tr>
                    <td>SHT12102112323</td>
                    <td>30.12.2021</td>
                    <td>1000</td>
                    <td>Bkash</td>
                    <td>Rakin</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../lib/Loader';

export default {
  name: 'PaymentHistory',
  components: {
    Loader
  },
  data() {
    return {
      isLoading: true
    };
  }
};
</script>

<style scoped>

</style>